import { PropsWithChildren } from 'react';
import { AffiliatesBaseSectionProps } from './props';
import styles from './styles.module.scss';

export default function AffiliatesBaseSection({
  title,
  children,
  icon,
}: PropsWithChildren<AffiliatesBaseSectionProps>) {
  return (
    <div className={styles.container}>
      <h6 className={styles.container__title}>
        {icon && <i className={icon} />} {title}
      </h6>
      {children}
    </div>
  );
}
